<template>
  <i class="o-icon">
    <component :is="src" :style="style" :class="srcClass" />
  </i>
</template>

<script>
  export default {
    name: 'Icon',
    props: {
      src: {
        type: [String, Object],
        required: true,
      },
      height: {
        type: Number,
        default: 24,
      },
      srcClass: {
        type: String,
        default: '',
      },
      color: {
        type: String,
        default: 'currentColor',
      },
    },
    computed: {
      style() {
        return {
          height: `${this.height}px`,
          width: `${this.height}px`,
          fill: this.color,
        };
      },
    },
  };
</script>
<style lang="scss" scoped>
  .o-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    &.icon {
      svg {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
</style>
